// extracted by mini-css-extract-plugin
module.exports = {"PrivacyPolicy":"_3swgarT6","privacyContent":"_1HsdQ74i","firstPrivacyContent":"soDnYXxj","privacyContentAddress":"_2Vt_qPw8","privacyContentIndented":"_3f17Wlio","privacyBold":"_1HxXo8-R","privacyUnderline":"_1UVDZpt7","privacyText":"_1T087RWH","emailLink":"_18dxFlhI"};
    if(module.hot) {
      // 1746735762644
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  